import { ProposalWarning } from 'src/app/models/proposal-warning';
import { Component, OnInit ,Input } from '@angular/core';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import Helper from 'src/app/core/utility/helper';
import Calculator from 'src/app/core/utility/calculator';
import { ProposalPackageLevel } from 'src/app/models/proposalpackagelevel';

/**
 *  TMS-14254 Flag to PE when new submitted proposal for an existing part does not match the last approved proposal
 */
@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss']
})

export class WarningComponent implements OnInit {
  @Input()
  proposalWarning: ProposalWarning;
  @Input()
  globalUOM: UnitOfMeasurement;
  
  warningSummary: string = '';

  constructor() {

  }

  ngOnInit() {
    if (this.validateProposalWarning(this.proposalWarning)) {
      this.warningSummary = `Existing Approved Proposal(${this.proposalWarning.ProposalId}): Supplier Code: ${this.proposalWarning.SupplierCode}, Supplier Name: ${this.proposalWarning.SupplierName}, Part Number: ${this.proposalWarning.PartNumber}`;
    }
  }

  getPackageLevelPropertyValue(levelIndex: number, propName: string) {
    if (!this.validateProposalPackageLevelIndex(this.proposalWarning, levelIndex) ||
        !propName) {
        return '';
    }

    const value = this.proposalWarning.ProposalPackageLevels[levelIndex][propName];
    
    return value ? value : '';
  }

  getDims(levelIndex: number) {
    if (!this.validateProposalPackageLevelIndex(this.proposalWarning, levelIndex)) {
        return '';
    }
    
    const length = Helper.calculateDim(this.getPackageLevelPropertyValue(levelIndex , 'Length'), this.globalUOM, false);
    const width = Helper.calculateDim(this.getPackageLevelPropertyValue(levelIndex , 'Width'), this.globalUOM, false);
    const height = Helper.calculateDim(this.getPackageLevelPropertyValue(levelIndex , 'Height'), this.globalUOM, false);

    return  `${length} (L) x ${width} (W) x ${height} (H)`;
  }

  validateProposalWarning(proposalWarning: ProposalWarning) {
    return proposalWarning &&
          proposalWarning.ProposalId &&
          proposalWarning.SupplierCode &&
          proposalWarning.SupplierName &&
          proposalWarning.PartNumber;
  }

  validateProposalPackageLevelIndex(proposalWarning: ProposalWarning, levelIndex: number) {
    return proposalWarning &&
          proposalWarning.ProposalPackageLevels &&
          proposalWarning.ProposalPackageLevels.length &&
          proposalWarning.ProposalPackageLevels.length >= levelIndex + 1 &&
          proposalWarning.ProposalPackageLevels[levelIndex];
  }

  /**
   * TMS-14254 Flag to PE when new submitted proposal for an existing part does not match the last approved proposal
   * Calculate the total part quantity (QPC) for already approved proposal in warning ingo.
   * @param level 
   * @returns the total part quantity (QPC) at the given proposal package level
   */
  getTotalPartQuantity(level: number) {
    const proposalWarning = this.proposalWarning;
    if (level >= 0 &&
        proposalWarning && 
        proposalWarning.ProposalPackageLevels &&
        proposalWarning.ProposalPackageLevels.length >= level) {
      const primaryPackageLevel = proposalWarning.ProposalPackageLevels[0];
      const secondaryPackageLevel = proposalWarning.ProposalPackageLevels[1];
      const tertiaryPackageLevel = proposalWarning.ProposalPackageLevels[2];
      const primaryQPC = primaryPackageLevel.QPC;
      let secondaryTotalPartQuantity = null;
      if (secondaryPackageLevel) {
          secondaryTotalPartQuantity = Calculator.GetTotalPartQuantity_Secondary(primaryQPC, secondaryPackageLevel.ContainersPerLayer, secondaryPackageLevel.NoOfLayers);
      }
      switch (level) {
          case 1: {
              return primaryQPC;
          }
          case 2: {
              return secondaryTotalPartQuantity;
          }
          case 3: {
              if (tertiaryPackageLevel) {
                  return Calculator.GetTotalPartQuantity_Tertiary(secondaryTotalPartQuantity, tertiaryPackageLevel.ContainersPerLayer, tertiaryPackageLevel.NoOfLayers);
              } 
              return null;
          }
      }
    }
  }
}
